import {
  SET_PROFILE_FROM_REDUX,
  SET_PROFILE_FROM_DB,
  SET_PROFILES,
  UPDATE_PROFILE,
  LOADING_PROFILE,
  SET_PROFILE_NOT_FOUND,
  RESET_PROFILE,
} from '../types'

const initialState = {
  profiles: [],
  profile: null,
  loading: false,
  notFound: false,
}

const profileReducer = (state = initialState, action) => {
  let index
  switch (action.type) {
    case LOADING_PROFILE:
      return {
        ...state,
        loading: true,
      }
    case SET_PROFILE_FROM_DB:
      return {
        ...state,
        profile: action.payload,
        loading: false,
      }

    case SET_PROFILE_FROM_REDUX:
      index = state.profiles.findIndex((doc) => doc.id === action.payload)
      if (index !== -1) {
        state.profile = state.profiles[index]
      } else {
        state.notFound = true
      }
      return {
        ...state,
        loading: false,
      }

    case SET_PROFILES:
      return {
        ...state,
        profiles: action.payload,
        loading: false,
      }

    case UPDATE_PROFILE:
      index = state.profiles.findIndex((doc) => doc.id === action.payload.id)
      state.profiles[index] = { ...state.profiles[index], ...action.payload }
      return {
        ...state,
      }

    case SET_PROFILE_NOT_FOUND:
      return {
        ...state,
        notFound: true,
        loading: false,
        profile: null,
      }

    case RESET_PROFILE:
      return initialState
    default:
      return state
  }
}

export default profileReducer
